import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getRegulatoryBody, updateRegulatoryBody} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateRegulatoryBodyForm extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    regulatoryBody: PropTypes.object.isRequired,
    getRegulatoryBody: PropTypes.func.isRequired,
    updateRegulatoryBody: PropTypes.func.isRequired
  };

  componentDidMount() {
    this._loadRegulatoryBody();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.regulatoryBodyId !== this.props.match.params.regulatoryBodyId) {
      this._loadRegulatoryBody();
    }
  }

  _loadRegulatoryBody = () => {
    const {regulatoryBodyId} = decodeParams(this.props.match.params);
    this.props.getRegulatoryBody({regulatoryBodyId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {regulatoryBodyId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateRegulatoryBody({...values, regulatoryBodyId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {regulatoryBody, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name} = regulatoryBody;
    return (
      <Card title="Update Regulatory Body">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Regulatory Body
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateRegulatoryBodyPage = Form.create()(UpdateRegulatoryBodyForm);

const mapStateToProps = state => ({
  loading: state.regulatoryBody.regulatoryBodyLoading || state.regulatoryBody.updatingRegulatoryBody || false,
  regulatoryBody: state.regulatoryBody.regulatoryBody || {}
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getRegulatoryBody,
  updateRegulatoryBody,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(UpdateRegulatoryBodyPage);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/UpdateRegulatoryBodyPage.js